import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon } from '../lib/icons';
const OFFER_STACK = ['6 módulos completos', '3 guías prácticas descargables', 'Libro de trabajo diario', 'Guía completa de chakras', 'Guía de meditaciones aplicadas', 'Acceso digital inmediato', 'Acceso de por vida'];
const BONUSES = [{
  title: 'Libro de Trabajo',
  subtitle: 'Ejercicios prácticos para integrar cada nivel',
  value: '$9.990',
  image: 'https://cdn.magicpatterns.com/uploads/aD3Rzvz9ZP5RFRn4kDkGzt/ChatGPT_Image_5_feb_2026,_16_27_39.png'
}, {
  title: 'Guía de Chakras',
  subtitle: 'Mapa completo de los centros energéticos',
  value: '$7.990',
  image: 'https://cdn.magicpatterns.com/uploads/sPkoe46vwtSddz9EgxNRu4/ChatGPT_Image_5_feb_2026,_16_27_43.png'
}, {
  title: 'Meditaciones',
  subtitle: 'Audio-guías para tu práctica diaria',
  value: '$8.990',
  image: 'https://cdn.magicpatterns.com/uploads/5aZmLeTL5kP6YtJeo4ys2w/ChatGPT_Image_5_feb_2026,_16_48_24.png'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#1a1208] py-20 md:py-28 px-4 relative overflow-hidden" data-id="element-55">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-56">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#d4a017]/10 rounded-full blur-[120px]" data-id="element-57"></div>
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#5a8a6a]/10 rounded-full blur-[100px]" data-id="element-58"></div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-59">
        {/* Header */}
        <div ref={ref1} className={`reveal text-center mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-60">
          <span className="inline-block py-1 px-4 rounded-full bg-[#d4a017]/20 border border-[#d4a017]/40 text-[#f0c040] text-xs font-bold tracking-[0.2em] uppercase mb-6" data-id="element-61">
            Regalos Exclusivos
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#f5ede0] mb-6 leading-tight" data-id="element-62">
            Inscríbete hoy y recibe estos{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" data-id="element-63">
              3 Bonos de Regalo
            </span>
          </h2>
          <p className="text-xl text-[#f5ede0]/70 max-w-2xl mx-auto font-light" data-id="element-64">
            Herramientas complementarias diseñadas para potenciar tu aprendizaje
            y facilitar tu práctica diaria.
          </p>
        </div>

        {/* Bonuses Grid */}
        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-8 mb-20 justify-items-center ${vis2 ? 'is-visible' : ''}`} data-id="element-65">
          {BONUSES.map((bonus, idx) => <div key={idx} className="group relative bg-[#2a2218] rounded-2xl p-6 border border-[#d4a017]/20 hover:border-[#d4a017]/50 transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_-15px_rgba(212,160,23,0.15)] w-full max-w-sm mx-auto" data-id="element-66">
              {/* Badge */}
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#d4a017] to-[#b8860b] text-[#1a1208] text-xs font-bold px-4 py-1.5 rounded-full shadow-lg z-20 whitespace-nowrap" data-id="element-67">
                BONO #{idx + 1} · GRATIS
              </div>

              {/* Image */}
              <div className="relative mb-6 rounded-xl overflow-hidden h-48 md:h-44 group-hover:shadow-lg transition-all" data-id="element-68">
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1208]/80 to-transparent z-10" data-id="element-69"></div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700" data-id="element-70" />
              </div>

              {/* Content */}
              <div className="text-center flex flex-col items-center" data-id="element-71">
                <h3 className="text-2xl font-serif font-bold text-[#f5ede0] mb-2 group-hover:text-[#f0c040] transition-colors" data-id="element-72">
                  {bonus.title}
                </h3>
                <p className="text-[#f5ede0]/60 text-sm mb-4 min-h-[40px]" data-id="element-73">
                  {bonus.subtitle}
                </p>
                <div className="flex items-center justify-center gap-3 text-sm" data-id="element-74">
                  <span className="text-[#f5ede0]/40 line-through decoration-[#d4a017]/50" data-id="element-75">
                    Valor: ARS {bonus.value}
                  </span>
                  <span className="text-[#5a8a6a] font-bold uppercase tracking-wide" data-id="element-76">
                    HOY: GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total Value & List */}
        <div className="max-w-4xl mx-auto bg-[#f5ede0] rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-77">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" data-id="element-78"></div>

          <div className="text-center mb-10" data-id="element-79">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#2a1f0e] mb-2" data-id="element-80">
              Resumen de todo lo que te llevas:
            </h3>
            <p className="text-[#5c4a2a]/70" data-id="element-81">
              Acceso inmediato a la plataforma + todos los bonos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 mb-10" data-id="element-82">
            {OFFER_STACK.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-83">
                <div className="mt-1 flex-shrink-0" data-id="element-84">
                  <CheckIcon className="w-5 h-5 text-[#1a6b3a]" strokeWidth={3} data-id="element-85" />
                </div>
                <span className="text-lg text-[#2a1f0e] font-medium leading-tight" data-id="element-86">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center pt-8 border-t border-[#d4a017]/20" data-id="element-87">
            <p className="text-sm text-[#5c4a2a]/60 uppercase tracking-widest mb-2 font-semibold" data-id="element-88">
              Valor Total Real:{' '}
              <span className="line-through" data-id="element-89">ARS $49.990</span>
            </p>
            <p className="text-3xl md:text-4xl font-serif font-bold text-[#1a6b3a]" data-id="element-90">
              Hoy todo incluido por solo{' '}
              <span className="text-[#d4a017]" data-id="element-91">ARS $19.990</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}